import { useEffect, useState } from 'react';

/**
 * React hook for matching CSS media queries
 *
 * Usage:
 *   const isCompact = useMediaQuery('(max-width: 767px)');
 *   const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
 *
 * Note: Use useIsCompactLayout() instead for the standard responsive breakpoint.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);

    // Set initial value
    onChange();

    // Listen for changes
    mql.addEventListener?.('change', onChange);

    return () => mql.removeEventListener?.('change', onChange);
  }, [query]);

  return matches;
}
